import React, { useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { timestampToDate } from '../../utils/firebase-timestamp-transformation';

const CSVExport = () => {
  const [exporting, setExporting] = useState(false);

  // Function to convert timestamp fields to JavaScript dates
  const convertTimestampFields = (data) => {
    const timestampFields = ['createdAt', 'dob', 'lastUpdated', 'emailMigratedAt'];
    const convertedData = { ...data };
    
    timestampFields.forEach(field => {
      if (convertedData[field]) {
        const convertedDate = timestampToDate(convertedData[field]);
        convertedData[field] = convertedDate ? convertedDate.toISOString() : '';
      }
    });
    
    return convertedData;
  };

  // Function to escape CSV fields
  const escapeCSVField = (field) => {
    if (field === null || field === undefined) return '';
    
    const stringField = String(field);
    
    // If field contains comma, newline, or quotes, wrap in quotes and escape internal quotes
    if (stringField.includes(',') || stringField.includes('\n') || stringField.includes('"')) {
      return `"${stringField.replace(/"/g, '""')}"`;
    }
    
    return stringField;
  };

  // Function to convert array of objects to CSV
  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';
    
    // Get all unique keys from all objects
    const allKeys = new Set();
    data.forEach(item => {
      Object.keys(item).forEach(key => allKeys.add(key));
    });
    
    const headers = Array.from(allKeys).sort();
    
    // Create header row
    const csvHeaders = headers.map(escapeCSVField).join(',');
    
    // Create data rows
    const csvRows = data.map(item => {
      return headers.map(header => escapeCSVField(item[header] || '')).join(',');
    });
    
    return [csvHeaders, ...csvRows].join('\n');
  };

  // Function to download CSV file
  const downloadCSV = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // Main export function
  const handleExport = async () => {
    try {
      setExporting(true);
      
      // Fetch all employees from Firestore
      const myelinersRef = collection(db, 'myeliners');
      const snapshot = await getDocs(myelinersRef);
      
      if (snapshot.empty) {
        alert('No employee data found to export.');
        return;
      }
      
      const employees = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        // Convert timestamp fields to JavaScript dates
        const convertedData = convertTimestampFields(data);
        employees.push(convertedData);
      });
      
      // Convert to CSV
      const csvContent = convertToCSV(employees);
      
      // Generate filename with current date
      const currentDate = new Date().toISOString().split('T')[0];
      const filename = `employees_export_${currentDate}.csv`;
      
      // Download the file
      downloadCSV(csvContent, filename);
      
      alert(`Successfully exported ${employees.length} employee records to ${filename}`);
      
    } catch (error) {
      console.error('Error exporting employees:', error);
      alert(`Error exporting employees: ${error.message}`);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="csv-export-container">
      <button 
        className="csv-export-btn"
        onClick={handleExport}
        disabled={exporting}
      >
        {exporting ? 'Exporting...' : 'Export All Employees to CSV'}
      </button>
    </div>
  );
};

export default CSVExport; 